import { render, staticRenderFns } from "./WidgetDashboardQuickButtons.vue?vue&type=template&id=a1cfb22c"
import script from "./WidgetDashboardQuickButtons.vue?vue&type=script&lang=js"
export * from "./WidgetDashboardQuickButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports